const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

export const getStorageUrl = (path) => {
  if (!path) return '';

  // Absolute URLs (http:// or https://) — return as-is
  if (path.startsWith('http')) return path;

  // Resolve storage paths against the API base URL
  const baseUrl = API_BASE_URL.replace(/\/api\/?$/, '');
  if (path.startsWith('/storage/')) {
    return baseUrl + path;
  }
  return baseUrl + '/storage/' + path;
};
